import { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, TextField, Alert, CircularProgress } from '@mui/material'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createBomVersion, type BomListItem } from '../../api/productie'
import { errorMessage } from '../../api/client'

export default function NewBomVersionDialog({ target, onClose, onCreated }: { target: BomListItem | null; onClose: () => void; onCreated: () => void }) {
  const open = target !== null
  const qc = useQueryClient()
  const [changeReason, setChangeReason] = useState('')

  const mutation = useMutation({
    mutationFn: () => createBomVersion(target!.id, changeReason || null),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['productie', 'retetar'] })
      setChangeReason('')
      onCreated()
      onClose()
    },
  })

  const handleClose = () => { setChangeReason(''); mutation.reset(); onClose() }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Versiune nouă pentru {target?.code} (v{target ? target.version + 1 : ''})</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 0.5 }}>
          <TextField label="Motivul versiunii noi (opțional)" value={changeReason} onChange={(e) => setChangeReason(e.target.value)}
            fullWidth multiline minRows={2} placeholder="Ex. schimbare matriță, schimbare furnizor folie, optimizare proces" />
          {mutation.isError && <Alert severity="error">{errorMessage(mutation.error)}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={handleClose}>Renunță</Button>
        <Button variant="contained" disabled={mutation.isPending} onClick={() => mutation.mutate()}
          startIcon={mutation.isPending ? <CircularProgress size={16} color="inherit" /> : undefined}>
          Creează versiunea
        </Button>
      </DialogActions>
    </Dialog>
  )
}
